import { createContext, useContext } from "react";
import useDiscoveryExhibits from "../hooks/useDiscoveryExhibits";

const DiscoveryExhibitContext = createContext(null);

export const DiscoveryExhibitProvider = ({ children }) => {
    const value = useDiscoveryExhibits();

    return <DiscoveryExhibitContext.Provider value={value}>
        {children}
    </DiscoveryExhibitContext.Provider>;
};

export const useDiscoveryExhibitContext = () => {
    const context = useContext(DiscoveryExhibitContext);

    if (!context) {
        throw new Error("useDiscoveryExhibitContext must be used within DiscoveryExhibitProvider");
    }

    return context;
};
